import * as React from "react";
import { styled } from "@mui/system";
import MUITextField, { TextFieldProps } from "@mui/material/TextField";

type Props = {
  readOnly?: boolean;
} & TextFieldProps;

export const TextField = styled(
  React.forwardRef((props: Props, ref: any) => (
    <MUITextField
      placeholder={props.placeholder}
      spellCheck="false"
      helperText={props.helperText}
      InputLabelProps={{ shrink: true }}
      fullWidth
      inputProps={{ readOnly: props.readOnly }}
      sx={{
        "input[type=number]::-webkit-inner-spin-button": {
          WebkitAppearance: "none",
          margin: 0,
        },
        "&.MuiTextField-root": {
          paddingLeft: 0,
          paddingRight: 0,
        },
        "& fieldset": { top: 0 },
        "& legend": {
          display: "none",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          top: 0,
        },

        "fieldset ": {
          borderColor: props.disabled
            ? "primary.borderDisabled"
            : props.error
            ? "primary.borderError"
            : "primary.borderDefault",
          cursor: props.disabled ? "not-allowed" : null,
          pointerEvents: props.disabled ? "all !important" : null,
        },
        "input ": {
          textAlign: props.type === "number" ? "right" : "left",
          paddingLeft: 0,
          paddingRight: 0,
          cursor: "auto",
        },
        svg: {
          color:
            props.disabled || props.readOnly
              ? "primary.iconDisabled"
              : "primary.iconDefault",
        },
      }}
      {...props}
      ref={ref}
    />
  )),
  {
    name: "TextField",
    slot: "Root",
    overridesResolver: (props, styles) => [
      props.disabled ? styles.disabled : null,
      styles.root,
    ],
  }
)(({ theme }) => ({}));
